import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, TicketStatus, TicketStatusId, TicketViewModel } from '../../../models';
import { IAuthentication, ILoggerService } from '../../../services';
import { dropTicket } from './dropTicket';
import { Roles } from '../../../common/constants';

class TicketingKanbanController implements angular.IComponentController {
    authentication: IAuthentication;
    currentUserGuid: string;
    dropDisabled: { [statusId: number]: boolean };
    isLoading: boolean;
    loadingMessage: string;
    originalTicketViewModel: TicketViewModel;
    saveTicket: ({ ticket: Ticket }) => angular.IPromise<void>;
    selectedTicketViewModel: TicketViewModel;
    ticketStatusList: TicketStatus[];
    ticketViewModelList: TicketViewModel[];
    visibleTicketStatusList: TicketStatus[];
    width: string;

    static $inject = ['$scope', '$translate', 'loggerService'];

    constructor(
        private _$scope: angular.IScope,
        private _$translate: angular.translate.ITranslateService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {       
        this._$scope.$watch(
            () => this.selectedTicketViewModel,
            (newValue) => {
                if (newValue) {
                    const isMaster = this.userInRole([Roles.master]);
                    if (!isMaster) {
                        const dropDisabled = {};
                        this.visibleTicketStatusList.forEach(d => dropDisabled[d.id] = this.selectedTicketViewModel.assignableStatuses.indexOf(d.id) < 0);
                        this.dropDisabled = dropDisabled;
                    }
                }
        });
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes['ticketStatusList'] && changes['ticketStatusList'].currentValue) {
            const isMaster = this.userInRole([Roles.master]);
            const ticketStatusList = changes['ticketStatusList'].currentValue as TicketStatus[];
            this.visibleTicketStatusList = _.filter(ticketStatusList, ticketStatus => ticketStatus && ticketStatus.isVisible);
            if (!isMaster) {
                const dropDisabled = {};
                this.visibleTicketStatusList.forEach(d => dropDisabled[d.id] = false);
                this.dropDisabled = dropDisabled;
            }
            this.width = (100 / this.visibleTicketStatusList.length) + '%';
        }

        if (changes['authentication']?.currentValue) {
            this.currentUserGuid = this.authentication.userGuid;
        }
    }

    ticketStatusListCount(): number {
        if (this.ticketStatusList && this.ticketStatusList.length) {
            return this.ticketStatusList.length;
        }
        return 0;
    }

    drop(data: any, ticketStatusId: number) {
        const promise = dropTicket(data, ticketStatusId, this.currentUserGuid, this.ticketViewModelList, this.saveTicket);
        if (promise) {
            promise
                .then((d) => {
                    if (d && d.statusId === TicketStatusId.Assigned && d.assignedUser === this.currentUserGuid && new Date(d.dueDate) < new Date()) {
                        this._loggerService.logError(this._$translate.instant('Due date is exceeded'));
                    }
                });
        }
    }

    // Check if user has at least an allowed role
    private userInRole(roles: string[]): boolean {
        //this._currentUser.roles
        return _.some(this.authentication.roles, r => roles.indexOf(r) >= 0);
    }
}

export const wtTicketingKanban: ComponentDefinition = {
    componentId: 'wtTicketingKanban',
    controller: TicketingKanbanController,
    template: require('./ticketingKanban.component.html'),
    controllerAs: 'vm',
    bindings: {
        authentication: '<',
        isLoading: '<',
        message: '<',
        originalTicketViewModel: '=',
        saveTicket: '&',
        selectedTicketViewModel: '=',
        ticketStatusList: '<',
        ticketViewModelList: '<',
        users: '<',
    }
};